export enum State {
  OFF,
  ON,
}
